export const ALL_PRODUCT_REQUEST="ALL_PRODUCT_REQUEST";
export const ALL_PRODUCT_SUCCESS="ALL_PRODUCT_SUCCESS";
export const ALL_PRODUCT_FAIL="ALL_PRODUCT_FAIL";

export const ADMIN_PRODUCT_REQUEST="ADMIN_PRODUCT_REQUEST";
export const ADMIN_PRODUCT_SUCCESS="ADMIN_PRODUCT_SUCCESS";
export const ADMIN_PRODUCT_FAIL="ADMIN_PRODUCT_FAIL";

export const NEW_PRODUCT_REQUEST="NEW_PRODUCT_REQUEST";
export const NEW_PRODUCT_SUCCESS="NEW_PRODUCT_SUCCESS";
export const NEW_PRODUCT_RESET="NEW_PRODUCT_RESET";
export const NEW_PRODUCT_FAIL="NEW_PRODUCT_FAIL";

export const UPDATE_PRODUCT_REQUEST="UPDATE_PRODUCT_REQUEST";
export const UPDATE_PRODUCT_SUCCESS="UPDATE_PRODUCT_SUCCESS";
export const UPDATE_PRODUCT_RESET="UPDATE_PRODUCT_RESET";
export const UPDATE_PRODUCT_FAIL="UPDATE_PRODUCT_FAIL";

export const DELETE_PRODUCT_REQUEST="DELETE_PRODUCT_REQUEST";
export const DELETE_PRODUCT_SUCCESS="DELETE_PRODUCT_SUCCESS";
export const DELETE_PRODUCT_RESET="DELETE_PRODUCT_RESET";
export const DELETE_PRODUCT_FAIL="DELETE_PRODUCT_FAIL";

export const PRODUCT_DETAILS_REQUEST="PRODUCT_DETAILS_REQUEST";
export const PRODUCT_DETAILS_SUCCESS="PRODUCT_DETAILS_SUCCESS";
export const PRODUCT_DETAILS_FAIL="PRODUCT_DETAILS_FAIL";

export const NEW_REVIEW_REQUEST="NEW_REVIEW_REQUEST";
export const NEW_REVIEW_SUCCESS="NEW_REVIEW_SUCCESS";
export const NEW_REVIEW_RESET="NEW_REVIEW_RESET";
export const NEW_REVIEW_FAIL="NEW_REVIEW_FAIL";

export const ALL_REVIEW_REQUEST="ALL_REVIEW_REQUEST";
export const ALL_REVIEW_SUCCESS="ALL_REVIEW_SUCCESS";
export const ALL_REVIEW_FAIL="ALL_REVIEW_FAIL";

export const DELETE_REVIEW_REQUEST="DELETE_REVIEW_REQUEST";
export const DELETE_REVIEW_SUCCESS="DELETE_REVIEW_SUCCESS";
export const DELETE_REVIEW_RESET="DELETE_REVIEW_RESET";
export const DELETE_REVIEW_FAIL="DELETE_REVIEW_FAIL";


export const CLEAR_ERRORS="CLEAR_ERRORS";

export const LOGIN_REQUEST="LOGIN_REQUEST";
export const LOGIN_SUCCESS="LOGIN_SUCCESS";
export const LOGIN_FAIL="LOGIN_FAIL";

export const REGISTER_USER_REQUEST="REGISTER_USER_REQUEST";
export const REGISTER_USER_SUCCESS="REGISTER_USER_SUCCESS";
export const REGISTER_USER_FAIL="REGISTER_USER_FAIL";

export const LOAD_USER_REQUEST="LOAD_USER_REQUEST";
export const LOAD_USER_SUCCESS="LOAD_USER_SUCCESS";
export const LOAD_USER_FAIL="LOAD_USER_FAIL";

export const LOGOUT_SUCCESS="LOGOUT_SUCCESS";
export const LOGOUT_FAIL="LOGOUT_FAIL";

export const UPDATE_PROFILE_REQUEST="UPDATE_PROFILE_REQUEST";
export const UPDATE_PROFILE_SUCCESS="UPDATE_PROFILE_SUCCESS";
export const UPDATE_PROFILE_RESET="UPDATE_PROFILE_RESET";
export const UPDATE_PROFILE_FAIL="UPDATE_PROFILE_FAIL";

export const UPDATE_PASSWORD_REQUEST="UPDATE_PASSWORD_REQUEST";
export const UPDATE_PASSWORD_SUCCESS="UPDATE_PASSWORD_SUCCESS";
export const UPDATE_PASSWORD_RESET="UPDATE_PASSWORD_RESET";
export const UPDATE_PASSWORD_FAIL="UPDATE_PASSWORD_FAIL";

export const FORGOT_PASSWORD_REQUEST="FORGOT_PASSWORD_REQUEST";
export const FORGOT_PASSWORD_SUCCESS="FORGOT_PASSWORD_SUCCESS";
export const FORGOT_PASSWORD_FAIL="FORGOT_PASSWORD_FAIL";

export const RESET_PASSWORD_REQUEST="RESET_PASSWORD_REQUEST";
export const RESET_PASSWORD_SUCCESS="RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_FAIL="RESET_PASSWORD_FAIL";

export const ALL_USERS_REQUEST="ALL_USERS_REQUEST";
export const ALL_USERS_SUCCESS="ALL_USERS_SUCCESS";
export const ALL_USERS_FAIL="ALL_USERS_FAIL";

export const USER_DETAILS_REQUEST="USER_DETAILS_REQUEST";
export const USER_DETAILS_SUCCESS="USER_DETAILS_SUCCESS";
export const USER_DETAILS_FAIL="USER_DETAILS_FAIL";

export const UPDATE_USER_REQUEST="UPDATE_USER_REQUEST";
export const UPDATE_USER_SUCCESS="UPDATE_USER_SUCCESS";
export const UPDATE_USER_RESET="UPDATE_USER_RESET";
export const UPDATE_USER_FAIL="UPDATE_USER_FAIL";

export const DELETE_USER_REQUEST="DELETE_USER_REQUEST";
export const DELETE_USER_SUCCESS="DELETE_USER_SUCCESS";
export const DELETE_USER_RESET="DELETE_USER_RESET";
export const DELETE_USER_FAIL="DELETE_USER_FAIL";



export const ADD_TO_CART="ADD_TO_CART";
export const REMOVE_CART_ITEM="REMOVE_CART_ITEM";

export const SAVE_SHIPPING_INFO="SAVE_SHIPPING_INFO";

export const CREATE_ORDER_REQUEST="CREATE_ORDER_REQUEST";
export const CREATE_ORDER_SUCCESS="CREATE_ORDER_SUCCESS";
export const CREATE_ORDER_FAIL="CREATE_ORDER_FAIL";

export const MY_ORDER_REQUEST="MY_ORDER_REQUEST";
export const MY_ORDER_SUCCESS="MY_ORDER_SUCCESS";
export const MY_ORDER_FAIL="MY_ORDER_FAIL";

export const ALL_ORDER_REQUEST="ALL_ORDER_REQUEST";
export const ALL_ORDER_SUCCESS="ALL_ORDER_SUCCESS";
export const ALL_ORDER_FAIL="ALL_ORDER_FAIL";

export const UPDATE_ORDER_REQUEST="UPDATE_ORDER_REQUEST";
export const UPDATE_ORDER_SUCCESS="UPDATE_ORDER_SUCCESS";
export const UPDATE_ORDER_RESET="UPDATE_ORDER_RESET";
export const UPDATE_ORDER_FAIL="UPDATE_ORDER_FAIL";

export const DELETE_ORDER_REQUEST="DELETE_ORDER_REQUEST";
export const DELETE_ORDER_SUCCESS="DELETE_ORDER_SUCCESS";
export const DELETE_ORDER_RESET="DELETE_ORDER_RESET";
export const DELETE_ORDER_FAIL="DELETE_ORDER_FAIL";


export const ORDER_DETAILS_REQUEST="ORDER_DETAILS_REQUEST";
export const ORDER_DETAILS_SUCCESS="ORDER_DETAILS_SUCCESS";
export const ORDER_DETAILS_FAIL="ORDER_DETAILS_FAIL";

export const EMPTY_CART_DATA = "EMPTY_CART_DATA";